const houseOfDragonS01E05 = {
  videoId: 'house_of_dragon_05',
  episodeTag: 'S01E05',
  railLabel: 'S01·A05',
  quickQuestions: [
    '这个角色是谁',
    '解释这个镜头',
    '这是什么梗',
    '这句台词什么意思',
  ],
};

export default houseOfDragonS01E05;
